import Plugin from '@ckeditor/ckeditor5-core/src/plugin'; 

import makeCommentCommand from './makecommentcommand';

export default class CommentEditing extends Plugin {

    init() {

        this._defineSchema();

        this._defineConverters();

        this.editor.commands.add( 'insertComment', new makeCommentCommand( this.editor ) );

    }

    _defineSchema(){

        // this.editor.model.schema.register('comment',{
        //     allowWhere:'$text',
        //     isInline: true,
        //     isContent: true
        // });

        // this.editor.model.schema.register('span',{
        //     allowWhere:'$text',
        //     isInline: true,
        //     isContent: true
        // });

        // this.editor.model.schema.register('comment', {
        //     allowWhere: '$text',
        //     allowContentOf: '$block'
        // });

        // this.editor.model.schema.register('span', {
        //     allowWhere: '$text',
        //     allowContentOf: '$block'
        // });

    }

    _defineConverters(){

        this.editor.conversion.for( 'upcast' ).dataToMarker({
            view: 'comment',
            model: ( name, conversionApi ) => {

                return 'comment:' + name

            },
	        converterPriority: 'high'
        });

        this.editor.conversion.for( 'downcast' ).markerToHighlight({
            model: 'comment',
            view: ({ markerName }) => {

                // Assuming "maker-group:marker-id".
                let [ , id ] = markerName.split( ':' );

                if ( !id ) {

                    id = Math.floor( Math.random() * 352 );

                }
        
                return {
                    classes: 'comment',
                    attributes: {
                        'data-marker' : 'comment',
                        'data-comment-id': id
                    }
                }
            },
            converterPriority: 'high'
        });

        this.editor.conversion.for( 'dataDowncast' ).markerToData({
            model: 'comment',
            view: markerName => ({
                group: 'comment',
                name: markerName.substr( 8 )
            }),
            converterPriority: 'high'
        } );

    }

}